import React from "react";
import ArtistFavoritesContainer from "~/Containers/ArtistFavoritesContainer";
import ArtistName from "~/Components/Elements/ArtistName";

import styled from "styled-components";

export const WrapperSection = styled.section`
  margin-bottom: 20px;
`;
export const Wrapper = styled.section`
  line-height: 18px;
  margin-bottom: 6px;
  display: inline-block;
  background-color: #eaeaea;
  padding: 6px 12px;
  margin-right: 8px;
  border-radius: 5px;
  a {
    &:hover {
      color: #333;
    }
  }
`;
const UserFavoriteArtists = ({ dir }) => (
  <ArtistFavoritesContainer
    dir={dir}
    render={({ artists }) => {
      return (
        artists.length > 0 && (
          <WrapperSection>
            <div className="totd-header mb">
              <h3>Favorite Artists</h3>
            </div>
            <div>
              {artists.map((artist) => (
                <Wrapper>
                  <ArtistName track={{ artist: artist.name }} link={true} />
                </Wrapper>
              ))}
            </div>
          </WrapperSection>
        )
      );
    }}
  />
);

export default UserFavoriteArtists;
